import { render, staticRenderFns } from "./addReserveDiningList.vue?vue&type=template&id=3565a084&scoped=true"
import script from "./addReserveDiningList.vue?vue&type=script&lang=js"
export * from "./addReserveDiningList.vue?vue&type=script&lang=js"
import style0 from "./addReserveDiningList.vue?vue&type=style&index=0&id=3565a084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565a084",
  null
  
)

export default component.exports